import {
  GET_AUTHSERVICE_BRANDS,
  GET_AUTHSERVICE_BY_BRAND,
  GET_BANK_ACCOUNTS,
  GET_ORDER_WARRANTY,
  POST_MERCHANT_APPEAL,
  POST_CONTACT,
  buildPublicApiUrl,
} from './publicConstants';

const REQUEST_TIMEOUT_MS = 30000;

async function request(path, options = {}) {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);

  try {
    const response = await fetch(buildPublicApiUrl(path), {
      ...options,
      signal: controller.signal,
    });

    if (!response.ok) {
      const errorText = await response.text().catch(() => '');
      throw new Error(errorText || `Request failed with status ${response.status}`);
    }

    if (options.responseType === 'text') {
      return response.text();
    }

    if (response.status === 204) {
      return null;
    }

    return response.json();
  } finally {
    clearTimeout(timeoutId);
  }
}

async function requestJson(path) {
  return request(path, {
    headers: {
      Accept: 'application/json',
    },
  });
}

export function fetchBankAccounts() {
  return requestJson(GET_BANK_ACCOUNTS);
}

export function fetchWarrantyBySerial(serialNumber) {
  return requestJson(`${GET_ORDER_WARRANTY}${encodeURIComponent(serialNumber)}`);
}

export function fetchAuthorizedServiceBrands(prefix) {
  return requestJson(`${GET_AUTHSERVICE_BRANDS}${encodeURIComponent(prefix)}`);
}

export function fetchAuthorizedServicesByBrand(brandId) {
  return requestJson(`${GET_AUTHSERVICE_BY_BRAND}${encodeURIComponent(brandId)}`);
}

export function postMerchantAppeal(payload) {
  return request(POST_MERCHANT_APPEAL, {
    method: 'POST',
    headers: {
      Accept: 'text/plain, application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
    responseType: 'text',
  });
}

export function postContact(payload) {
  return request(POST_CONTACT, {
    method: 'POST',
    headers: {
      Accept: 'text/plain, application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
    responseType: 'text',
  });
}
